import { create } from 'zustand'

/**
 * Who answers "C" and the header "+ Task" (design 25a).
 *
 * A page whose list has an inline quick-add row (TaskPageLayout) registers an
 * opener while it's mounted; the header controls (ProjectViewControls) call it
 * when present and fall back to the Create Task dialog otherwise. Exactly one
 * `c` hotkey is live at a time: the most recently mounted header claims it,
 * and TaskPageLayout keeps its own only while no header is mounted (task pages
 * like Inbox have no ProjectViewControls).
 */
type QuickAddState = {
  openInline: (() => void) | null
  /** Mounted header controls, oldest first. The last one owns the hotkey. */
  controlIds: Array<string>
  registerInline: (open: () => void) => () => void
  registerControls: (id: string) => () => void
}

export const useQuickAddStore = create<QuickAddState>()((set) => ({
  openInline: null,
  controlIds: [],
  registerInline: (open) => {
    set({ openInline: open })
    return () =>
      set((state) => (state.openInline === open ? { openInline: null } : state))
  },
  registerControls: (id) => {
    set((state) => ({ controlIds: [...state.controlIds.filter((x) => x !== id), id] }))
    return () =>
      set((state) => ({ controlIds: state.controlIds.filter((x) => x !== id) }))
  },
}))
